module.exports = __webpack_public_path__ + "static/media/hot.8ed75e39.mp3";